import { createQueryClientWithSentry } from "@repo/common/lib/query-client-sentry";

export const queryClient = createQueryClientWithSentry({
  defaultOptions: {
    queries: {
      retry: 1,
    },
  },
});
